import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LoadingSpinner from './LoadingSpinner';

const OrganizationChoiceRoute = ({ element }) => {
  const { user, status } = useSelector((state) => state.user);
  const location = useLocation();
  
  // Show loading while checking authentication
  if (status === "loading" || user === undefined) {
    return <LoadingSpinner message="Loading..." />;
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If user already has an organization, redirect based on onboarding status
  if (user.currentOrganization) {
    if (user.currentOrganization.onboarding && !user.currentOrganization.onboarding.isCompleted) {
      const currentStep = user.currentOrganization.onboarding.currentStep || 'welcome';
      return <Navigate to={`/onboarding/${currentStep}`} replace />;
    } else {
      return <Navigate to="/rooms" replace />;
    }
  }

  // User is authenticated but has no organization - allow access to organization choice
  return element;
};

export default OrganizationChoiceRoute; 